// extracted by mini-css-extract-plugin
export default {"description":"changeBasic_description__hHylr","content":"changeBasic_content__WNDf2","contentItem":"changeBasic_contentItem__6l7rX","mt12":"changeBasic_mt12__eBR2o"};